import { syntaxTreeModule } from "@mem-labs/common-editor";

export const createNoteEncodedContentFromTitle = (
  title: string
): { encodedContent: string; primaryLabel: string; secondaryLabel: string } => {
  const h1 = document.createElement("h1");
  h1.textContent = title;
  const p = document.createElement("p");
  const html = document.createElement("html");
  html.appendChild(h1);
  html.appendChild(p);

  const htmlContent = html.outerHTML;
  const encodedContent = syntaxTreeModule.convertHtmlToEncodedContent({ htmlContent });
  return { encodedContent, primaryLabel: title, secondaryLabel: "" };
};
